
<div>
    <app-bar :title="product.name"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8">
            <div class="pb-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <v-btn
                    v-if="permitted('admin_club_management')"
                    class="sm mr-5"
                    color="primary"
                    outlined
                    @click.prevent="suspend(product)"
                >
                    {{ product.enabled ? t('general_action_suspend') : t('general_action_unsuspend') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_club_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="del(product)"
                >
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 394px; max-width: 394px">
                <img
                    v-if="product.photoUrl"
                    :src="product.photoUrl"
                    width="150"
                />
                <div class="form-subtitle">{{ t('club_product_label_description') }}:</div>
                <div class="form-subtitle-description" v-html="product.description"></div>
                <div v-if="product.link" class="form-subtitle">{{ t('club_product_label_link') }}:</div>
                <div v-if="product.link" class="form-subtitle-description">{{ product.link }}</div>
                <div v-if="linkParamRows().length" class="form-subtitle">{{ t('club_product_label_link_params') }}:</div>
                <div v-if="linkParamRows().length" class="form-subtitle-description">
                    <div v-for="row in linkParamRows()" :key="row.key">{{ row.key }}: {{ row.value }}</div>
                </div>
                <template v-if="product.photos && product.photos.length">
                    <div class="form-subtitle mb-3">{{ t('club_product_label_header_photos') }}:</div>
                    <v-row>
                        <v-col
                            v-for="photo in product.photos"
                            :key="photo"
                            cols="6"
                        >
                            <v-sheet
                                color="white"
                                elevation="0"
                                height="185"
                                width="185"
                                rounded="lg"
                                class="pt-6"
                            >
                                <v-img
                                    :lazy-src="photo"
                                    :src="photo"
                                    max-height="135"
                                    max-width="135"
                                    class="mx-auto"
                                ></v-img>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </template>
            </div>
            <div class="float-left" style="max-width: calc(100% - 434px)">
                <card-unit :items="items()">
                    <template #title>{{ t('club_product_label_id') }}: {{ product.id }}</template>
                </card-unit>
            </div>
        </div>
    </v-layout>
</div>
